/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientBasicInfoDto } from './ClientBasicInfoDto';
import type { PolicyCommissionResponseDto } from './PolicyCommissionResponseDto';
import type { PolicyPremiumFundingDetailsDto } from './PolicyPremiumFundingDetailsDto';
import type { PolicyRiskResponseDto } from './PolicyRiskResponseDto';
export type PolicyResponseDto = {
    /**
     * Policy UUID
     */
    id: string;
    /**
     * Quote UUID
     */
    quoteId?: string | null;
    /**
     * Client UUID
     */
    clientId: string;
    /**
     * Basic client information
     */
    client: ClientBasicInfoDto;
    /**
     * Policy status
     */
    status: PolicyResponseDto.status;
    /**
     * Policy type
     */
    policyType: PolicyResponseDto.policyType;
    /**
     * Assigned adviser UUID
     */
    assignedAdviserId?: string | null;
    /**
     * Servicing adviser UUID
     */
    servicingAdviserId?: string | null;
    /**
     * Original servicing adviser UUID
     */
    originalServicingAdviserId?: string | null;
    /**
     * Assigned adviser user UUID
     */
    assignedAdviserUserId?: string | null;
    /**
     * Assigned adviser name
     */
    assignedAdviserName?: string | null;
    /**
     * Servicing adviser user UUID
     */
    servicingAdviserUserId?: string | null;
    /**
     * Servicing adviser name
     */
    servicingAdviserName?: string | null;
    /**
     * List of products included in policy
     */
    products?: Record<string, any> | null;
    /**
     * Ando-aligned header snapshot (includes offering, cover dates, etc.)
     */
    header?: Record<string, any> | null;
    /**
     * Policy net total
     */
    policyNetTotal: number;
    /**
     * Start date
     */
    startDate: string;
    /**
     * Expiry date
     */
    expiryDate: string;
    /**
     * Enforced date
     */
    enforcedDate?: string | null;
    /**
     * Renewal date
     */
    renewalDate?: string | null;
    /**
     * Payment frequency
     */
    paymentFrequency: PolicyResponseDto.paymentFrequency;
    /**
     * Payment status
     */
    paymentStatus: PolicyResponseDto.paymentStatus;
    /**
     * MTA metadata payload
     */
    mta?: Record<string, any> | null;
    /**
     * Cancellation metadata payload
     */
    cancellationMetadata?: Record<string, any> | null;
    /**
     * Original policy UUID for MTA
     */
    originalPolicyId?: string | null;
    /**
     * Original policy details for MTA
     */
    originalPolicy?: PolicyResponseDto | null;
    /**
     * Total premium from the original policy when this policy is an MTA
     */
    originalPolicyTotalPremium?: number | null;
    /**
     * Persisted gross annual premium for MTA policies
     */
    mtaGrossAnnualPremium?: number | null;
    /**
     * Gross annual premium currently in force for this policy. Resolves to the MTA gross annual premium for MTA policies and the total premium otherwise
     */
    currentGrossAnnualPremium?: number | null;
    /**
     * MTA version number
     */
    mtaVersion?: number | null;
    /**
     * Superseding MTA policy UUID
     */
    replacedByMTAId?: string | null;
    /**
     * Auto issued flag
     */
    autoIssued: boolean;
    /**
     * Imported status
     */
    importedStatus: PolicyResponseDto.importedStatus;
    /**
     * Ando quote reference
     */
    andoQuoteId?: string | null;
    /**
     * Timestamp of last successful Ando sync
     */
    andoSyncedAt?: string | null;
    /**
     * Last Ando sync error message (if any)
     */
    andoSyncError?: string | null;
    /**
     * Last request payload sent to Ando
     */
    lastAndoRequest?: Record<string, any> | null;
    /**
     * Last response payload received from Ando (or error body)
     */
    lastAndoResponse?: Record<string, any> | null;
    /**
     * Ando keys
     */
    andoKeys?: Record<string, any> | null;
    /**
     * Total premium
     */
    totalPremium?: number | null;
    /**
     * Total commission
     */
    totalCommission?: number | null;
    /**
     * Total tax
     */
    totalTax?: number | null;
    /**
     * Policy total tax (15% of net premium + fees)
     */
    policyTotalTax?: number | null;
    /**
     * Total net premium
     */
    totalNetPremium?: number | null;
    /**
     * Total tax on commission
     */
    totalTaxOnCommission?: number | null;
    /**
     * Admin fee
     */
    adminFee?: number | null;
    /**
     * Broker fee
     */
    brokerFee?: number | null;
    /**
     * Total (totalPremium + adminFee + brokerFee)
     */
    total?: number | null;
    /**
     * Per-risk premium details from Ando response (JSON array)
     */
    riskPremiums?: Record<string, any> | null;
    /**
     * Premium funding quote details from accepted eOffer for funded policies
     */
    premiumFundingDetails?: PolicyPremiumFundingDetailsDto | null;
    /**
     * Commission split stored for this policy
     */
    policyCommission?: PolicyCommissionResponseDto | null;
    /**
     * Policy risks
     */
    risks: Array<PolicyRiskResponseDto>;
    /**
     * Created timestamp
     */
    createdAt: string;
    /**
     * Updated timestamp
     */
    updatedAt: string;
    /**
     * Created by user UUID
     */
    createdBy?: string | null;
    /**
     * Updated by user UUID
     */
    updatedBy?: string | null;
};
export namespace PolicyResponseDto {
    /**
     * Policy status
     */
    export enum status {
        SAVED = 'SAVED',
        ISSUED = 'ISSUED',
        VALID = 'VALID',
        EXPIRED = 'EXPIRED',
        ENDED = 'ENDED',
        CANCELLED = 'CANCELLED',
        DECLINED = 'DECLINED',
        SUPERSEDED = 'SUPERSEDED',
        REFERRAL_SUBMITTED = 'REFERRAL_SUBMITTED',
        REFERRAL_ACTION_REQUIRED = 'REFERRAL_ACTION_REQUIRED',
        QUOTED = 'QUOTED',
    }
    /**
     * Policy type
     */
    export enum policyType {
        POLICY = 'POLICY',
        MTA = 'MTA',
        POLICY_RENEWAL = 'POLICY_RENEWAL',
    }
    /**
     * Payment frequency
     */
    export enum paymentFrequency {
        WEEKLY = 'WEEKLY',
        FORTNIGHTLY = 'FORTNIGHTLY',
        MONTHLY = 'MONTHLY',
        ANNUAL = 'ANNUAL',
    }
    /**
     * Payment status
     */
    export enum paymentStatus {
        NOT_PAID = 'NOT_PAID',
        PAID = 'PAID',
        OVERDUE = 'OVERDUE',
    }
    /**
     * Imported status
     */
    export enum importedStatus {
        IMPORTED = 'IMPORTED',
        MANUAL_ENTRY = 'MANUAL_ENTRY',
        API_SYNC = 'API_SYNC',
    }
}

